import { handleResponseErr } from '../../utils/handleResponseErr'
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import { ModalActions } from 'semantic-ui-react'

const DEFAULT_STATE = {
  companies: null,
  company: null,
  currencies:null,
  currency:null,
  actions:{
    companies_status: {
      loading: false,
      errMsg: null,
    },
    create_company: {
      loading: false,
      errMsg: null,
      success: false,
    },
    get_company: {
      loading: false,
      errMsg: null,
     
    },
    currencies_status: {
      loading: false,
      errMsg: null,
      
    
    },
    update_company:{
      loading: false,
      errMsg: null,
      success: false,
    },

    delete_company:{
      loading: false,
      errMsg: null,
      success: false
    }
  }
}

export default function companies (state = DEFAULT_STATE, action) {
  switch (action.type) {
    /***********************
     * Get Companies List
     ************************/
    // on pending
    case "GET_COMPANIES_PENDING":
      return {
        ...DEFAULT_STATE,
        actions: {
          ...state.actions,
          companies_status: { loading: true },
        },
      };

    // on success
    case "GET_COMPANIES_FULFILLED":
      return {
        ...state,
        companies: action.payload.data.data.companies,
        actions: {
          ...state.actions,
          companies_status: DEFAULT_STATE.actions.companies_status,
        },
      };

    // on rejected
    case "GET_COMPANIES_REJECTED":
      return {
        ...state,
        actions: {
          ...state.actions,
          companies_status: {
            loading: false,
            errMsg: handleResponseErr(action.payload),
          },
        },
      };

    /***********************
     * Create new company
     ************************/
    // on pending
    case "CREATE_COMPANY_PENDING":
      return {
        ...state,
        actions: {
          ...state.actions,
          create_company: { loading: true },
        },
      };

    case "CREATE_COMPANY_FULFILLED":
      console.log('companies',state)
      const companies = state.companies;
      
   companies.unshift(action.payload.data.data.company);
      iziToast.success({
        title: "Success",
        message: action.payload.data.message,
        zindex: 50000,
        position: "topCenter",
        timeout: 3000,
        animateInside: false,
      });
      return {
        ...state,
        companies,
        actions: {
          ...state.actions,
          create_company: {
            ...DEFAULT_STATE.actions.create_company,
            success: true,
          },
        },
      };

    // on rejected
    case "CREATE_COMPANY_REJECTED":
      return {
        ...state,
        actions: {
          ...state.actions,
          create_company: {
            loading: false,
            errMsg: handleResponseErr(action.payload),
          },
        },
      };

    case "RESET_CREATE_FORM":
      return {
        ...state,
        actions: {
          ...state.actions,
          create_company: {
            ...DEFAULT_STATE.actions.create_company,
          },
        },
      };

    /***********************
     * Create new company
     ************************/
    case "GET_COMPANY_PENDING":
      return {
        ...state,
        actions: {
          ...state.actions,
          get_company: { loading: true },
        },
      };

    case "GET_COMPANY_FULFILLED":
      return {
        ...state,
        company: action.payload.data.data.company,
        actions: {
          ...state.actions,
          get_company: DEFAULT_STATE.actions.get_company,
        },
      };

    /***********************
     * Update company
     ************************/
    case "UPDATE_COMPANY_PENDING":
      return {
        ...state,
        actions: {
          ...state.actions,
          update_company: { loading: true },
        },
      };
    case "UPDATE_COMPANY_FULFILLED":
      return {
        ...state,
        actions: {
          ...state.actions,
          update_company: {
            ...DEFAULT_STATE.actions.update_company,
            loading: false,
            success: true,
          },
        },
      };

    case "UPDATE_COMPANY_REJECTED":
      return {
        ...state,
        actions: {
          ...state.actions,
          update_company: {
            loading: false,
            errMsg: handleResponseErr(action.payload),
          },
        },
      };

    case "RESET_UPDATE_FORM":
      return {
        ...state,
        actions: {
          ...state.actions,
          update_company: DEFAULT_STATE.actions.update_company,
        },
      };
    /*************
     * Get  Currency**/
    /**********************/
  // on pending
  case "GET_CURRENCIES_PENDING":
    return {
      ...DEFAULT_STATE,
      actions: {
        ...state.actions,
        currencies_status: { loading: true },
      },
    };

  // on success
  case "GET_CURRENCIES_FULFILLED":
    return {
      ...state,
      currencies:action.payload.data.data.currencies,
      actions: {
        ...state.actions,
        currencies_status: DEFAULT_STATE.actions.currencies_status,
      },
    };

  // on rejected
  case "GET_CURRENCIES_REJECTED":
    return {
      ...state,
      actions: {
        ...state.actions,
        currencies_status: {
          loading: false,
          errMsg: handleResponseErr(action.payload),
        },
      },
    };

   
    /***********************
     * Get Companies List
     ************************/
    case "DELETE_COMPANY_PENDING":
      return {
        ...state,
        actions: {
          ...state.actions,
          delete_company: { loading: true },
        },
      };

    case "DELETE_COMPANY_REJECTED":
      return {
        ...state,
        actions: {
          ...state.actions,
          delete_company: {
            loading: false,
            errMsg: handleResponseErr(action.payload),
          },
        },
      };

    case "DELETE_COMPANY_FULFILLED":
      iziToast.success({
        title: "Success",
        message: action.payload.data.message,
        zindex: 50000,
        position: "topCenter",
        timeout: 3000,
        animateInside: false,
      });
      return {
        ...state,
        actions: {
          ...state.actions,
          delete_company: {
            loading: false,
            success: true,
          },
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/companies.js